import { Component } from '@angular/core';
import { WaitingListComponent } from '../waiting-list/waiting-list.component';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';

@Component({
    selector: 'app-waiting-list-dialog',
    templateUrl: './waiting-list-dialog.component.html',
    styleUrl: './waiting-list-dialog.component.scss',
    imports: [
        WaitingListComponent,
    ],
})
export class WaitingListDialogComponent extends BaseDialogComponent {

}
